import { useMutation } from "@tanstack/react-query";
import { ClassService } from "../../services/class.service";
import { IClassUpdateModel, IClassUpdateResult } from "../../models/Class";

export const useClassMutations = () => {
  const { mutate: updateClass, isPending: isUpdatingClass } = useMutation<
    IClassUpdateResult,
    Error,
    { id: string; model: IClassUpdateModel }
  >({
    mutationFn: async ({ id, model }) =>
      ClassService.updateClassByGymListingId(id, model).then((res) => res.data),
  });

  return {
    updateClass,
    isUpdatingClass,
  };
};
